import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import ReservationGroupUpsertForm from './form/reservation-group-upsert.form'
import { ReservationGroupUpsertFilter } from './form/reservation-group.types'

type ReservationNewDrawerProps = {
  propertyId: string
  loading?: boolean
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  onGoToCreateSingleReservation?: () => void
  onSubmitAndOpenReservation?: (reservationId: string) => void
  reservedResourceId?: string
  planningInfo?: {
    resourceTypeId: string
    resourceId?: string
  }
  filter?: ReservationGroupUpsertFilter
}

export default function ReservationUpsertDrawer(props: ReservationNewDrawerProps) {
  const { lg } = useBreakpoints()

  const onSubmitComplete = () => props.onConfirm()

  const onCancelHandler = () => props.onCancel()

  return (
    <ReservationGroupUpsertForm
      loading={props.loading}
      reservedResourceId={props.reservedResourceId}
      formLayoutProps={{
        appearance: {
          type: 'DRAWER',
          open: props.open,
          onClose: () => {
            props.onCancel()
          },
          width: lg ? 900 : '100%',
          titleOnLeft: true,
        },
      }}
      propertyId={props.propertyId}
      onSubmitComplete={onSubmitComplete}
      onCancel={onCancelHandler}
      filter={props.filter}
      planningInfo={props.planningInfo}
      onGoToCreateSingleReservation={props.onGoToCreateSingleReservation}
      onSubmitAndOpenReservation={props.onSubmitAndOpenReservation}
    />
  )
}
